import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=a67cc6d2&scoped=true&"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67cc6d2",
  null
  
)

export default component.exports